import { ReadOnlyKeyValueStorage } from './ReadOnlyKeyValueStorage';

let cookieCacheKey: string;
const cookieCache = new Map<string, string>();

function getItemFromCookieString(
  cookieString: string,
  key: string,
): string | undefined {
  if (cookieCacheKey !== cookieString) {
    cookieCache.clear();
    cookieCacheKey = cookieString;

    const cookies = cookieString.split('; ');

    for (let i = 0; i < cookies.length; i += 1) {
      const [foundKey, ...value] = cookies[i].split('=');

      cookieCache.set(foundKey, value.join('='));
    }
  }

  return cookieCache.get(key);
}

function getCookieItem(key: string): string | undefined {
  return getItemFromCookieString(document.cookie, key);
}

export function createCookieStorage(): ReadOnlyKeyValueStorage {
  return {
    getItem: getCookieItem,
  };
}
